import SchoolsTable from './SchoolsTable';
export default SchoolsTable;
